import { goals as staticGoals } from "./NewCompanyOnboarding";
import { InputField } from "../components/AIBotTab_1";
import { BotContext } from "../store";
import { useContext, useState } from "react";
import { motion } from "framer-motion";

interface Step1Props {
  botData: any;
  fetchUrl: (url: string) => Promise<void>;
  onDataChange: (field: string, value: any, isChatReset?: boolean) => void;
  websiteUrl: string;
  setWebsiteUrl: (val: string) => void;
  differentiatingFactor: string;
  setDifferentiatingFactor: (val: string) => void;
  selectedGoalIdx: number | null;
  setselectedGoalIdx: (idx: number) => void;
  customGoal: string;
  goals: any[];
  setGoals: (goals: any[]) => void;
  handleSelectGoal: (cat: string, selectedSubCat: any, idx: number) => void;
  handleQAChange: (cat: string, idx: number, value: string) => void;
  handleCustomGoalChange: (value: string) => void;
  train: boolean;
  setTrain: (val: boolean) => void;
  showGoalInputError: boolean;
  setShowGoalInputError: (val: boolean) => void;
}

const Step1 = ({
  botData,
  fetchUrl,
  onDataChange,
  websiteUrl,
  setWebsiteUrl,
  differentiatingFactor,
  setDifferentiatingFactor,
  selectedGoalIdx,
  setselectedGoalIdx,
  customGoal,
  goals,
  setGoals,
  handleSelectGoal,
  handleQAChange,
  handleCustomGoalChange,
  train,
  setTrain,
  showGoalInputError,
  setShowGoalInputError,
}: Step1Props) => {
  const [showCheck, setshowCheck] = useState<boolean | null>(null);
  const [store, storeDispatch] = useContext(BotContext);
  const goalsData = store.botData.goals?.categories;
  const miscSubCats =
    goalsData?.find((cat) => cat.cat === "Miscellaneous")?.subCat || [];
  const customGoals = botData.aiBotConfig?.customGoals?.data;
  const otherIdx = miscSubCats.length;
  const customGoalValue =
    (customGoals && customGoals[0]?.goals[0]?.content) || customGoal;

  const miscCategory = goals.find((g) => g.cat === "Miscellaneous");
  const activeGoal = miscCategory?.goals.find((g) => g.isActive);
  const selectedGoalQA = activeGoal?.q_a || [];

  const handleGoalClick = (cat: string, selectedSubCat: any, idx: number) => {
    handleSelectGoal(cat, selectedSubCat, idx);
  };

  return (
    <div className="flex w-full flex-col gap-[20px]">
      {/* <div className="flex flex-col items-center gap-[6px]">
        <h3 className="font-Rubik Regular Regulartext-center text-[16px] text-base font-medium not-italic leading-none text-[#444]">
          Welcome to Chatbot Builder
        </h3>
        <p className="font-Rubik Regular Regulartext-center text-[14px] font-normal not-italic leading-none text-[#999]">
          Tell us about your website
        </p>
      </div> */}
      <div className="flex w-full flex-col items-start gap-[10px]">
        <h3 className="text-center text-[12px] font-medium capitalize leading-[1.1] text-[#444]">
          Website URL:
        </h3>
        <div className="w-full rounded-[16px] bg-[#f9f9f9] p-[10px]">
          <InputField
            websiteUrl={websiteUrl}
            setWebsiteUrl={setWebsiteUrl}
            fetchUrl={fetchUrl}
            onDataChange={onDataChange}
            searchData={botData.searchLinkHistory}
            isOnboarding={true}
          />
          {websiteUrl && (
            <div className="crawl mt-[6px] flex w-full items-center justify-between gap-[10px] rounded-[12px] border border-[#aec9ed] bg-[#eff6ff] p-[15px]">
              <div className="flex flex-col gap-[6px]">
                <p className="text-left text-[14px] font-medium leading-none text-[#444]">
                  Website Crawling
                </p>
                <p className="text-[13px] leading-[19.5px] text-[#999]">
                  Would you like us to auto-crawl your website to enhance the
                  agent's knowledge?
                </p>
              </div>
              <div className="flex items-center gap-[10px]">
                <button
                  className={`flex items-center gap-[10px] rounded-[8px] px-[30px] py-[10px] text-[14px] transition-colors duration-200 ${
                    train === showCheck
                      ? "!border border-transparent !bg-[#FB5F66] text-white shadow-[0px_4px_20px_rgba(251,95,102,0.15)]"
                      : "!border !border-[#FB5F66] !bg-white !text-[#FB5F66] hover:!bg-[#FB5F66] hover:!text-white"
                  }`}
                  onClick={() => {
                    setTrain(true);
                    setshowCheck(true);
                  }}
                >
                  Yes
                  {train && showCheck && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="9"
                      viewBox="0 0 13 9"
                      fill="none"
                    >
                      <path
                        d="M11.0093 0.357949L5.18933 6.17787L2.52193 3.5104C2.12021 3.10868 1.46876 3.10861 1.06697 3.51033C0.665177 3.91212 0.665177 4.56351 1.06697 4.9653L4.46181 8.36028C4.65474 8.55323 4.91641 8.66164 5.18926 8.66166H5.18933C5.46217 8.66166 5.72384 8.55322 5.91678 8.36035L12.4643 1.81298C12.8661 1.41119 12.8661 0.759808 12.4643 0.358018C12.0625 -0.0437726 11.4111 -0.0438412 11.0093 0.357949Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </button>

                <button
                  className={`flex items-center gap-[10px] rounded-[8px] px-[30px] py-[10px] text-[14px] transition-colors duration-200 ${!train && showCheck ? "border !border-transparent bg-[#FB5F66] text-white shadow-[0px_4px_20px_rgba(251,95,102,0.15)]" : "border border-[#FB5F66] bg-[#FFFFFF] text-[#fb5f66] hover:!bg-[#FB5F66] hover:!text-white"}`}
                  onClick={() => {
                    setTrain(false);
                    setshowCheck(true);
                  }}
                >
                  No
                  {!train && showCheck && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="9"
                      viewBox="0 0 13 9"
                      fill="none"
                    >
                      <path
                        d="M11.0093 0.357949L5.18933 6.17787L2.52193 3.5104C2.12021 3.10868 1.46876 3.10861 1.06697 3.51033C0.665177 3.91212 0.665177 4.56351 1.06697 4.9653L4.46181 8.36028C4.65474 8.55323 4.91641 8.66164 5.18926 8.66166H5.18933C5.46217 8.66166 5.72384 8.55322 5.91678 8.36035L12.4643 1.81298C12.8661 1.41119 12.8661 0.759808 12.4643 0.358018C12.0625 -0.0437726 11.4111 -0.0438412 11.0093 0.357949Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex w-full flex-col items-start gap-[10px]">
        <h3 className="text-center text-[12px] font-medium capitalize not-italic leading-[1.1] text-[#444]">
          Core Agent Information
        </h3>
        <div className="w-full rounded-[16px] bg-[#f9f9f9] p-[10px]">
          <textarea
            placeholder="Describe the most important information your agent should know"
            className="min-h-[88px] resize-none rounded-[10px] border border-black/10 bg-white p-[15px]"
            value={differentiatingFactor}
            onChange={(e) => setDifferentiatingFactor(e.target.value)}
          />
        </div>
      </div>
      <div className="flex w-full flex-col items-start gap-[10px]">
        <h3 className="text-center text-[12px] font-medium capitalize not-italic leading-[1.1] text-[#444]">
          Main Goal:
        </h3>
        <div className="grid w-full grid-cols-[repeat(auto-fit,_minmax(220px,_1fr))] gap-[10px]">
          {miscSubCats.map((goal, index) => {
            const matchedGoal = staticGoals.find(
              (g) =>
                g.heading?.trim().toLowerCase() ===
                goal.title?.trim().toLowerCase(),
            );
            return (
              <motion.div
                key={goal._id}
                onClick={() => {
                  handleGoalClick("Miscellaneous", goal, index);
                  if (selectedGoalIdx !== index) {
                    setShowGoalInputError(false);
                  }
                }}
                className={`flex w-full cursor-pointer items-center gap-[10px] rounded-[16px] border border-transparent bg-[#F9F9F9] p-[10px] ${selectedGoalIdx === index ? "goal_is_active" : ""} goal-${selectedGoalIdx}`}
              >
                <div className="border-[rgba(0, 0, 0, 0.10)] grid !h-[44px] !w-[44px] place-items-center rounded-[15px] border bg-white">
                  {matchedGoal?.icon}
                </div>

                <div className="flex flex-col gap-[6px]">
                  <h4 className="text-[14px] font-medium not-italic leading-none text-[#444]">
                    {goal.title}
                  </h4>
                  <p className="text-[13px] font-normal not-italic leading-none text-[#666]">
                    {matchedGoal?.subHeading}
                  </p>
                </div>
              </motion.div>
            );
          })}
          {/* <div
            className={`flex w-full max-w-[329px] cursor-pointer items-center gap-[10px] rounded-[16px] border border-transparent bg-[#F9F9F9] p-[10px] ${selectedGoalIdx === otherIdx ? "goal_is_active" : ""}`}
            onClick={() => {
              setGoals(
                goals.map((category) =>
                  category.cat === "Miscellaneous"
                    ? {
                        ...category,
                        goals: category.goals.map((goal) => ({
                          ...goal,
                          isActive: false,
                        })),
                      }
                    : category,
                ),
              );
              setselectedGoalIdx(otherIdx);
              if(selectedGoalIdx !== otherIdx) {
                setShowGoalInputError(false);
              }
            }}
          >
            <div className="border-[rgba(0, 0, 0, 0.10)] grid !h-[44px] !w-[44px] place-items-center rounded-[15px] border bg-white">
              {staticGoals[staticGoals.length - 1]?.icon}
            </div>
            <div className="flex flex-col gap-[6px]">
              <h4 className="text-[14px] font-medium not-italic leading-none text-[#444]">
                {staticGoals[staticGoals.length - 1]?.heading}
              </h4>
              <p className="text-[13px] font-normal not-italic leading-none text-[#666]">
                {staticGoals[staticGoals.length - 1]?.subHeading}
              </p>
            </div>
          </div> */}
        </div>
      </div>
      {activeGoal && selectedGoalQA.length > 0 && (
        <div className="qa-section mt-4 flex w-full flex-col rounded-[16px] bg-[#f9f9f9] p-[16px]">
          {selectedGoalQA.map((qa, idx) => (
            <div key={idx} className="mb-2 flex w-full flex-col">
              <div className="mb-1 text-[13px] text-[#666]">{qa.question}</div>
              <input
                type="text"
                autoFocus
                className="w-full rounded-[8px] border border-black/10 bg-white p-[10px]"
                placeholder={qa.placeholder || "Enter answer"}
                value={qa.answer}
                onChange={(e) => {
                  setShowGoalInputError(false);
                  handleQAChange("Miscellaneous", idx, e.target.value);
                }}
              />
            </div>
          ))}
          {showGoalInputError && (
            <div className="mt-1 text-[12px] text-[#fb5f66]">
              Please fill all required fields for your main goal.
            </div>
          )}
        </div>
      )}
      {/* {selectedGoalIdx === otherIdx && (
        <div className="w-full rounded-[16px] bg-[#f9f9f9] p-[10px]">
          <input
            type="text"
            autoFocus
            placeholder="Please Specify your Goal..."
            className="rounded-[10px] border border-black/10 bg-white p-[15px]"
            value={customGoalValue}
            onChange={(e) => {
              setShowGoalInputError(false);
              handleCustomGoalChange(e.target.value);
            }}
          />
          {showGoalInputError && (
            <div className="text-[#fb5f66] text-[12px] mt-1">
              Please specify your main goal.
            </div>
          )}
        </div>
      )} */}
    </div>
  );
};

export default Step1;
